import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, TransferState, provideAppInitializer, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { translateBrowserLoaderFactory } from './core/translate/translate-browser.loader';
import { NgcCookieConsentConfig, NgcCookieConsentModule } from 'ngx-cookieconsent';
import { provideAnimations } from '@angular/platform-browser/animations';
import { GoogleLoginProvider, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';
import { firstValueFrom } from 'rxjs';
import { provideEchartsCore } from 'ngx-echarts';
import * as echarts from 'echarts/core';
import { MapChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { TooltipComponent, VisualMapComponent, GeoComponent } from 'echarts/components';

echarts.use([
  MapChart,
  CanvasRenderer,
  TooltipComponent,
  VisualMapComponent,
  GeoComponent
]);

export function isMobileDevice(): boolean {
  if (typeof navigator === 'undefined') return false; // SSR safe
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    //domain: 'localhost'
    domain: 'skeinforce.com'
  },
  "position": "bottom",
  palette: {
    popup: {
      background: '#fff'
    },
    button: {
      background: '#343435',
      text: "#fff",
    }
  },
  theme: 'edgeless',
  type: 'opt-out',
  content: {
    "message": "This website uses cookies to ensure you get the best experience on our website.",
    "dismiss": "Got it!",
    "deny": "Refuse cookies",
    "link": "",
    "href": "",
    "policy": "Change cookie settings",
    "allow": "Allow cookies"
  }
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({
      eventCoalescing: true
    }),
    provideRouter(routes),
    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({
        includePostRequests: false
      })
    ),

    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi()
    ),
    provideAnimations(),

    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '1004522455076-pm4ecc34hoss5mfbjrr0stlhuc2ihsgg.apps.googleusercontent.com'
            )
          },
        ]
      } as SocialAuthServiceConfig,
    },

    provideAppInitializer(async () => {

      const translate = inject(TranslateService);

      let lang = 'it';

      if (typeof document !== 'undefined') {

        const regex = /lang=([^;]+)/;

        const match = regex.exec(document.cookie);

        if (match?.[1]) {
          lang = match[1];
        }
      }

      translate.setFallbackLang(lang);

      await firstValueFrom(
        translate.use(lang)
      );

    }),

    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: translateBrowserLoaderFactory,
          deps: [HttpClient, TransferState],
        },
      }),
      //NgcCookieConsentModule.forRoot(cookieConfig),
      NgcCookieConsentModule.forRoot({
        ...cookieConfig,
        enabled: true,
      }),
    ),

    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    provideEchartsCore({ echarts })
  ]
};
